import React, { Fragment } from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Header from './header';
import Nav from './nav';
import Modules from './modules';
import QrCode from './qrCode';
import Cooperation from './cooperation';
import BottomFooter from './bottomFooter';
import Affix from './affix';
import { getTopicPreviewData } from '../../../services/api';
import { getUrlParams } from '../../../services/utils';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        docData: this.props.content.docData,
    };

    async componentDidMount() {
        if (location.href.includes('cmpp_user')) {
            const id = location.href.split('/special/')[1].split('?')[0];

            const data = getUrlParams();

            const docData = await getTopicPreviewData(id, encodeURIComponent(data.cookieInfo), data.biz, data.token);

            console.log(docData);

            this.setState({ docData: { ...docData } });
        }
    }

    render() {
        const { docData } = this.state;
        const {
            content: {
                channel,
                qrCode,
                footer,
                topAd,
                slideAd,
                infoAd,
                titleAd1,
                titleAd2,
                titleAd3,
                titleAd4,
                columnAd1,
                columnAd2,
                columnAd3,
                floatAd1,
                floatAd2,
                floatAd3,
                floatAd4,
            },
        } = this.props;

        const footerData = { footer };

        const adArr = {
            slideAd,
            infoAd,
            titleAd1,
            titleAd2,
            titleAd3,
            titleAd4,
            columnAd1,
            columnAd2,
            columnAd3,
        };

        const floatAd = {
            floatAd1,
            floatAd2,
            floatAd3,
            floatAd4,
        };
        const pcBannerImg = docData.pcBannerImg || '';
        const hideTitle = docData.hideTitle || 0;

        return (
            <div className={styles.topic}>
                <Header content={channel} />
                <div className={styles.bannerImg}>
                    {docData.hideTitle ? (
                        <Fragment>
                            {pcBannerImg ? (
                                <React.Fragment>
                                    <img src={pcBannerImg} />
                                </React.Fragment>
                            ) : (
                                ''
                            )}
                        </Fragment>
                    ) : (
                        <Fragment>
                            {pcBannerImg ? (
                                <React.Fragment>
                                    <img src={pcBannerImg} />
                                    <div className={styles.mask} />
                                </React.Fragment>
                            ) : (
                                ''
                            )}
                            <div className={pcBannerImg ? styles.banner_title : styles.noBanner_title}>
                                <h2>{hideTitle === 0 ? docData.title : ''}</h2>
                                <p>{docData && docData.introDisplay === 1 ? docData.introduction : ''}</p>
                            </div>
                        </Fragment>
                    )}
                </div>
                <div className={styles.layout}>
                    {docData.modules && (
                        <NoSSR>
                            <Nav content={docData.modules} slideDisplay={docData.slideDisplay} />
                        </NoSSR>
                    )}
                    <div className={styles.box_l}>
                        <NoSSR>
                            <Ad content={topAd} styleName={styles.top_bar} />
                        </NoSSR>
                        {docData.modules && <Modules docData={docData} content={docData.modules} ad={adArr} />}
                        <Cooperation content={docData.ad} />
                    </div>
                    <div className={styles.box_r}>
                        <NoSSR>
                            <Chip
                                type="struct"
                                id="170062"
                                title="PC专题页二维码"
                                groupName="正文侧栏"
                                content={qrCode}>
                                <QrCode />
                            </Chip>
                        </NoSSR>
                    </div>
                    <BottomFooter content={footerData} />
                </div>
                <NoSSR>
                    <Affix ad={floatAd} />
                </NoSSR>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
